<template>
  <!-- milk_det鲜奶的时候true ,否则false， -->
  <div class="mes_det">
    <div class="mes_mr border_top1px">
      <div
        class="flex_item font12 font_weight500 colo087 line_height_17 mr_top"
        @click="goChooseDate(item.deliveryPlanTime)"
      >
        <div>配送时间</div>
        <div class="font_weight400">
          <!-- 2020-09-01 至 2020-09-30 -->
          <span class="ms"
            >{{ startDate | dateFormatterJava("YYYY-MM-DD") }}
            至
            {{ endDate | dateFormatterJava("YYYY-MM-DD") }}
          </span>
          <img src="@/assets/common/icon_back_b87_24@2x.png" alt="" />
        </div>
      </div>
      <div
        class="flex_item mr_top font12 font_weight500 colo087 line_height_17"
      >
        <div>每次频率</div>
        <div>{{ item.periodNum }}件</div>
      </div>
    </div>
    <div class="date_exp">
      <div class="top_font text_left">
        <div class="font14 font_weight500 line_height_20 font_left">
          {{ item.totalPeriods }}期
        </div>
        <div class="font12 font_weight400 line_height_17 font_right">
          {{ startDate | dateFormatterJava("YYYY-MM-DD") }}至{{
            endDate | dateFormatterJava("YYYY-MM-DD")
          }}
          工作日配送，每次配送{{ item.periodNum }}件，预计首次发货时间{{
            startDate | dateFormatterJava("YYYY-MM-DD")
          }}号。
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    startDate() {
      // console.log(localStorage.getItem("mall-wap-pur-choosedate"), "dfsdfsdf"); mall-wap-exchange-card-choosedate
      const data = this.item;
      let startDate = "";
      if (localStorage.getItem("mall-wap-pur-choosedate")) {
        startDate = localStorage.getItem("mall-wap-pur-choosedate");
      } else if (localStorage.getItem("mall-wap-exchange-card-choosedate")) {
        startDate = localStorage.getItem("mall-wap-exchange-card-choosedate");
      } else {
        startDate = data.deliveryPlanTime;
      }
      // localStorage.getItem("mall-wap-pur-choosedate") ||
      // localStorage.getItem("mall-wap-exchange-card-choosedate")
      //   ? localStorage.getItem("mall-wap-pur-choosedate") ||
      //     localStorage.getItem("mall-wap-exchange-card-choosedate")
      //   : data.deliveryPlanTime;
      return startDate;
    },
    endDate() {
      // console.log(localStorage.getItem("mall-wap-pur-choosedate"), "dfsdfsdf");
      const data = this.item;
      let startDate = "";
      if (localStorage.getItem("mall-wap-pur-choosedate")) {
        startDate = localStorage.getItem("mall-wap-pur-choosedate");
      } else if (localStorage.getItem("mall-wap-exchange-card-choosedate")) {
        startDate = localStorage.getItem("mall-wap-exchange-card-choosedate");
      } else {
        startDate = data.deliveryPlanTime;
      }
      // const startDate =
      //   localStorage.getItem("mall-wap-pur-choosedate") ||
      //   localStorage.getItem("mall-wap-exchange-card-choosedate")
      //     ? localStorage.getItem("mall-wap-pur-choosedate") ||
      //       localStorage.getItem("mall-wap-exchange-card-choosedate")
      //     : data.deliveryPlanTime;
      const end =
        new Date(startDate.replace(/-/g, "/")).getTime() +
        new Date(
          (data.totalPeriods - 1) * data.periodInterval * 24 * 60 * 60 * 1000
        ).valueOf();
      // console.log(end);
      const endDate = dayjs(end).format("YYYY-MM-DD");
      return endDate;
    }
  },
  methods: {
    goChooseDate(deliveryPlanTime) {
      this.$emit("goChooseDate", deliveryPlanTime, this.startDate);
    }
  }
};
</script>

<style lang="less" scoped>
.mes_det {
  background: #fff;
  .mes_mr {
    margin: 0 12px;
  }
  .mr_top {
    padding-top: 12px;
  }
  .flex_item {
    padding-bottom: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    img {
      width: 24px;
      height: 24px;
      vertical-align: middle;
    }
    .ms {
      vertical-align: middle;
    }
  }
  .date_exp {
    // position: relative;
    background: url("../../../../../assets/order/milk_pur_bg@2x.png") 0 0
      no-repeat;
    background-size: 100% 100%;
    .top_font {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 12px 4px;
      .font_left {
        color: #fff7ea;
      }
      .font_right {
        width: 78%;
      }
    }
  }
}
</style>
